import React from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import "./Navbar.scss";
import { images } from "../../constants";
import { useState } from "react";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  const handleThemeMode = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.querySelector("body").setAttribute("data-theme", "dark");
    } else {
      document.querySelector("body").setAttribute("data-theme", "light");
    }
  };

  return (
    <nav className={`app__navbar ${isDarkMode ? "dark" : ""}`}>
      <div className="app__navbar-logo">
        <img src={isDarkMode ? images.logo2 : images.logo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((item) => {
          return (
            <li className="app__flex p-text" key={`link-${item}`}>
              <div />
              <a href={`#${item}`}>{item}</a>
            </li>
          );
        })}
      </ul>
      <div className="app__flex">
        <p className="p-text mx-2 my-0">Dark Mode</p>
        <label className="switch">
          <input type="checkbox" onChange={handleThemeMode} />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            initial={{ x: "100vw" }}
            animate={{
              x: 0,
            }}
            transition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX
              onClick={() => {
                setToggle(false);
              }}
            />

            <ul>
              {["home", "about", "work", "skills", "contact"].map((item) => {
                return (
                  <li key={item}>
                    <a
                      onClick={() => {
                        setToggle(false);
                      }}
                      href={`#${item}`}
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
